import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["HideFeaturedSlotToggle"] */ "/app/src/components/professionals/HideFeaturedSlotToggle.tsx");
